import React, { useRef } from 'react'

import { Box, Space, withCitrusTheme } from '@gousto-internal/citrus-react'

import { DeliveryDaysNDDBanner } from './DeliveryDaysNDDBanner'
import { useDeliveryEligibility } from '../hooks/useDeliveryEligibility'

const StyledBannerContainer = withCitrusTheme(Box, () => ({
  marginTop: '-16px',
}))

interface BoxSummaryNDDBannerProps {
  deliveryDate?: string
  isOverlayVisible?: boolean
}

/**
 * NDD Banner wrapper for the Box Summary page.
 * Displays dynamic next-day delivery messaging based on the selected delivery date.
 * Only tracks when the banner is actually visible in the viewport.
 *
 * @param deliveryDate - Optional delivery date string. If not provided, uses time-based eligibility.
 * @returns Banner component with spacing, or null if feature is disabled or no banner config available
 */
export const BoxSummaryNDDBanner: React.FC<BoxSummaryNDDBannerProps> = ({
  deliveryDate,
  isOverlayVisible = true,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const {
    isEnabled: isDeliveryEligibilityEnabled,
    bannerConfig,
    eligibility,
    timeLeft,
  } = useDeliveryEligibility('box-summary', deliveryDate)

  if (!isDeliveryEligibilityEnabled || !bannerConfig?.message) {
    return null
  }

  return (
    <>
      <StyledBannerContainer ref={containerRef}>
        {isOverlayVisible && (
          <DeliveryDaysNDDBanner
            bannerConfig={bannerConfig}
            eligibility={eligibility}
            timeLeft={timeLeft}
          />
        )}
      </StyledBannerContainer>
      <Space size={4} />
    </>
  )
}
